export interface PeriodicPromptReset {
  redirect: boolean;
  reset: boolean;
  different?: boolean;
}
